import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ErroImportacaoService {

    private baseUrl = environment.APIEndpoint;

    temErro: boolean = false;

    constructor() {}

    gerarHash(text: string): string {
        let hash = 5381; // Constante do djb2
        for (let i = 0; i < text.length; i++) {
            hash = ((hash << 5) + hash) + text.charCodeAt(i);
            hash = hash & hash; // Converte para 32-bit integer
        }
        return Math.abs(hash).toString();
    }

    verificarHash(text: string, hash: string): boolean {
        const generatedHash = this.gerarHash(text);
        return generatedHash === hash;
    }

}
